export const CHART_PALETTE = ["#0070F2", "#00B0FF", "#1E293B", "#64748B", "#94A3B8", "#0EA5E9"];
export const SAP_BLUE = "#0070F2";
